import React from "react";
import {Row, Col} from "react-bootstrap";
import config from "../../../config";

const Clairinfinity = () => {
    return (
        <div className="h-c-s">
            <Row>
                <Col className="h-c" xs={12} md={6} xl={6}>
                    <div className="info-container">
                        <span className="icon-clair-symbol"/>
                        <h2>
                            Sell Your Once-Loved
                        </h2>
                        <p>
                            Get a quick offer with Clair by Rebag, ship it, and get paid
                        </p>
                        <a href={`${config.host_rebag}/clair/`}>
                            Learn More <i/>
                        </a>
                    </div>
                </Col>
                <Col className="h-i-b-c" xs={12} md={6} xl={6}>
                    <div className="info-container">
                        <i className="icon-infinity"/>
                        <h2>INFINITY EXCHANGE</h2>
                        <p>
                            Turn in any Rebag purchase within 12 months for credit worth {config.infinity_value_range} of its purchase price to put toward your next
                        </p>
                        <a href={`${config.host_rebag}/infinity/`}>
                            Learn More <i/>
                        </a>
                    </div>
                </Col>
            </Row>
        </div>

    )
}

export default Clairinfinity;